<template>
  <div>
    <button @click="openAddNewAccreditedModal" class="float"><h2 class="plus-button">+</h2></button>
    <b-modal
      hide-footer
      size="xl"
      centered
      ref="add-Accredited-modal"
      id="add-Accredited-modal"
      title="ADICIONAR CREDENCIADA"
    >
    <template #modal-title>
      <div class="titulo-modal">ADICIONAR CREDENCIADA</div>
    </template>
      <b-form v-on:submit.prevent="onSubmit">
        <div class="title-1 title">Dados Básicos</div>
        <div class="container-user-form">
          <b-form-group
            class="w-75"
            id="input-group-name"
            label="Nome imobiliária:"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              class="mb-3"
              name="input-name"
              type="text"
              v-validate="{ required: true }"
              v-model="newAccreditedData.Nome"
              :state="validateState('input-name')"
              placeholder="Digite o nome da imobiliária"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-comercial-phone"
            class="w-50"
            label="Telefone Comercial:"
            label-for="input-comercial-phone"
          >
            <b-form-input
              id="input-comercial-phone"
              class="mb-3"
              name="input-comercial-phone"
              v-validate="{ required: true, numeric: false, length:14 }"
              v-model="newAccreditedData.TelefoneComercial"
              :state="validateState('input-comercial-phone')"
              type="text"
              placeholder="(__) ____-____"
              v-mask="['(##) ####-####']"
              required
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            class="w-75"
            id="input-group-email"
            label="E-mail Comercial:"
            label-for="input-email"
          >
            <b-form-input
              id="input-email"
              name="input-email"
              v-validate="{ required: true, email: true }"
              v-model="newAccreditedData.EmailComercial"
              :state="validateState('input-email')"
              type="email"
              placeholder="Digite o e-mail da imobiliária"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-dateBirth"
            class="w-50"
            label="Data de Cadastro:"
            label-for="input-dateBirth"
          >
            <b-form-input
              id="input-dateBirth"
              name="dateBirth"
              required
              :type="'date'"
              v-model="newAccreditedData.DataCadastro"
              :placeholder="$lang.Common.DatePlaceholder"
              v-validate="{ required: true }"
              :state="validateState('dateBirth')"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="container-user-form">
          <b-form-group
            id="input-group-creci"
            label="CRECI:"
            class="w-20"
            label-for="input-creci"
          >
            <b-form-input
              id="input-creci"
              name="input-creci"
              v-validate="{ required: true }"
              v-model="newAccreditedData.CRECI"
              :state="validateState('input-creci')"
              type="text"
              placeholder="Digite o número do CRECI"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-uf-creci"
            label="UF CRECI:"
            class="w-20"
            label-for="input-uf-creci"
          >
           <b-form-select
           id="input-uf-creci"
           name="input-uf-creci"
           :options="statesAcronym"
           v-validate="{ required: true }"
           :state="validateState('input-uf-creci')"
           v-model="newAccreditedData.CRECIUF"
           type="text"
           placeholder="Selecione"
           required
            ></b-form-select>
          </b-form-group>

          <b-form-group id="input-group-percentage"
            label="Percentual de comissão:"
            class="w-20"
            label-for="input-percentage">
            <b-form-input
              id="input-percentage"
              name="input-percentage"
              v-model="newAccreditedData.PercentualComissao"
              v-validate="{ required: true }"
              v-on:blur="formatLazyPercentage"
              :state="validateState('input-percentage')"
              type="text"
              placeholder="Percentual de comsissão"
              required
              :formatter="formatPercentage"
            ></b-form-input>
          </b-form-group>
          </div>

        <div class="title-2">Endereço</div>
        <div class="container-user-form">
          <b-form-group id="input-group-cep" label="CEP:" class="w-25" label-for="input-cep">
            <b-form-input
              id="input-cep"
              name="input-cep"
              v-validate="{ required: true, numeric: false, length: 9 }"
              v-model="newAccreditedData.cep"
              v-on:blur="searchAndress"
              :state="validateState('input-cep')"
              type="text"
              placeholder="_____-___"
              v-mask="['#####-###']"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-city"
            class="w-50"
            label="Cidade:"
            label-for="input-city"
          >
            <b-form-input
              id="input-city"
              name="input-city"
              :disabled="true"
              v-validate="{ required: true, alpha_spaces: true }"
              v-model="newAccreditedData.CidadeNome"
              :state="validateState('input-city')"
              type="text"
              placeholder="Digite o nome da cidade"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-address"
            label="Endereço:"
            class="w-50"
            label-for="input-address"
          >
            <b-form-input
              id="input-address"
              name="input-address"
              :disabled="true"
              v-validate="{ required: true, alpha_spaces:true }"
              v-model="newAccreditedData.Endereco"
              :state="validateState('input-address')"
              type="text"
              placeholder="Digite o endereço do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-district"
            label="Bairro:"
            class="w-50"
            label-for="input-district"
          >
            <b-form-input
              id="input-district"
              name="input-district"
              :disabled="true"
              v-validate="{ required: true, alpha_spaces: true }"
              v-model="newAccreditedData.Bairro"
              :state="validateState('input-district')"
              type="text"
              placeholder="Digite o endereço do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-number"
            label="Número:"
            label-for="input-number"
          >
            <b-form-input
              id="input-number"
              name="input-number"
              v-validate="{ required: true }"
              v-model="newAccreditedData.Numero"
              :state="validateState('input-number')"
              type="text"
              placeholder="Digite o número do usuário"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="container-buttons-form">
            <button @click="cancelNewAccredited" class="button-cancel">
              Cancelar
            </button>
            <button  @click="onSubmit" class="button-save">Salvar</button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Newaccredited from './newaccredited'
export default Newaccredited
</script>

<style scoped>
.float{
position:fixed;
width:60px;
height:60px;
bottom:40px;
right:40px;
background-color:#008148;
color:#FFF;
border-radius:50px;
text-align:center;
border: transparent;
}
.titulo-modal{
  color: white;
}
.float:hover{
background-color:#1f9c64;
}

.my-float{
margin-top: 23px;
margin-left: 2px;
}

.fa-plus:before {
    content: "\f067";
    color: white;
}

.title-modal{
  font: normal normal 600 18px/24px Segoe UI;
  letter-spacing: 0.27px;
  color: #404040;
  opacity: 1;
}

.form-nome-imobiliaria{
  top: 424px;
  left: 382px;
  width: 325px;
  height: 37px;
/* UI Properties */
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CED4DA;
  border-radius: 4px;
  opacity: 1;
}

.container-user-form{
  margin: 1rem 0 1rem 0;
    display: flex;
    gap: 1rem;
    /* display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr); */
}
.plus-button{
  font: 20px;
  margin-top: 3px;
}
.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

#input-group-name{
    grid-row: 2;
    grid-column: 1/4;
}

#input-group-comercial-phone{
    grid-row: 2;
    grid-column: 6/4;
}

#input-group-email{
    grid-row: 2;
    grid-column: 9/6;
}

#input-group-dateBirth{
    grid-row: 2;
    grid-column:  12/9;
}

#input-group-creci{
    grid-row: 3;
    grid-column: 1/3;
}
#input-group-uf-creci{
    grid-row: 3;
    grid-column: 3;
}

#input-group-percentage{
  grid-row: 3;
  grid-column: 4;
}
#input-group-rg{
    grid-row: 3;
    grid-column: 3/5;
}
#input-group-cpf{
    grid-row: 3;
    grid-column: 5/7;
}

#input-group-cep{
    grid-row: 5;
    grid-column: 1;
}
#input-group-city{
    grid-row: 5;
    grid-column: 2/4;
}
/* #input-group-state{
    grid-row: 5;
    grid-column: 4/4;
} */
#input-group-address{
    grid-row: 5;
    grid-column: 4/7;
}
#input-group-district{
    grid-row: 5;
    grid-column: 7/10;
}
#input-group-number{
    grid-row: 5;
    grid-column: 10;
}

.container-buttons-form{
    grid-row: 6;
    grid-column: 1/11;
}
.title-2{
  grid-row: 4;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/newaccredited/newaccredited.vue